
(() => {
  // ATHLETEGY - Global Quick Buy Color Synchronization
  // Keeps Quick Buy aligned with the selected product-card color.
  // Excludes Shop the Look, which has its own working script.

  const initializedCards = new WeakSet();

  function initializeCard(card) {
    if (initializedCards.has(card)) return;

    // Preserve our existing Shop the Look implementation.
    if (card.closest(".shopify-section--shop-the-look")) return;

    const productLink = card.querySelector(".product-card__media");
    const button = card.querySelector(
      ".product-card__quick-add-button[aria-controls]"
    );

    if (!productLink || !button) return;

    const modal = document.getElementById(
      button.getAttribute("aria-controls")
    );

    if (!modal || modal.tagName.toLowerCase() !== "quick-buy-modal") {
      return;
    }

    function synchronizeVariant() {
      const url = new URL(productLink.href, window.location.href);
      const variantId = url.searchParams.get("variant");
      const productHandle = card.getAttribute("handle");

      if (!variantId || !productHandle) return;

      const newHandle =
        `${productHandle}?variant=${encodeURIComponent(variantId)}`;

      if (modal.getAttribute("handle") !== newHandle) {
        modal.setAttribute("handle", newHandle);
      }
    }

    // Watch Prestige's existing color changes.
    const observer = new MutationObserver(synchronizeVariant);

    observer.observe(productLink, {
      attributes: true,
      attributeFilter: ["href"]
    });

    // Synchronize again when the customer opens Quick Buy.
    button.addEventListener("pointerdown", synchronizeVariant, true);
    button.addEventListener("click", synchronizeVariant, true);

    synchronizeVariant();
    initializedCards.add(card);
  }

  function initializeCards(root = document) {
    if (root.matches?.("product-card.product-card")) {
      initializeCard(root);
    }

    root.querySelectorAll?.("product-card.product-card")
      .forEach(initializeCard);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initializeCards();
      observeNewCards();
    });
  } else {
    initializeCards();
    observeNewCards();
  }

  function observeNewCards() {
    // Also handle product cards loaded by collection filters
    // or dynamically inserted Shopify sections.
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;

          if (
            node.matches?.("product-card.product-card") ||
            node.querySelector?.("product-card.product-card")
          ) {
            initializeCards(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
